export default ({ request }) => ({
  ordeDemandPackingListApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/list',
      method: 'post',
      data
    })
  },
  ordeDemandPackingSaveApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/save',
      method: 'post',
      data
    })
  },
  ordeDemandPackingDetailApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/detail',
      method: 'post',
      data
    })
  },
  ordeDemandPackingDelApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/del',
      method: 'post',
      data
    })
  },

  orderDemandPackageGoodsListApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/goods/list',
      method: 'post',
      data,
    })
  },
  orderDemandPackageGoodsBatchListApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/goods/batch/list',
      method: 'post',
      data,
    })
  },
  orderDemandPackageGoodsDelApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/goods/del',
      method: 'post',
      data,
    })
  },
  orderDemandPackageGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/goods/save',
      method: 'post',
      data,
    })
  },
  orderDemandPackageGoodsEditApi(data = {}) {
    return request({
      url: '/factory/order/demand/packing/goods/edit',
      method: 'post',
      data,
    })
  },
})
